import React from "react";
import "./HousekeepingHero.css";
import Navbar from "../Header/Navbar";
import { Link } from "react-router-dom";

const HousekeepingHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="hk-mini-hero">
        <div className="hk-mini-container">
          {/* Main Title */}
          <h1 className="hk-mini-title">
            Housekeeping & Janitorial Services
          </h1>

          {/* Breadcrumb */}
          <p className="hk-mini-breadcrumb">
            <Link to="/" className="hk-mini-link">Home</Link>
            <span>-</span>
            <Link to="/services" className="hk-mini-link">Our Services</Link>
            <span>-</span>
            <Link to="/housekeeping" className="hk-mini-link">
              Housekeeping & Janitorial Services
            </Link>
          </p>
        </div>
      </section>

      {/* TAG BELOW HERO */}
     
    </>
  );
};

export default HousekeepingHero;
